"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SwitchGroup;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Stack = _interopRequireDefault(require("../../layout/Stack"));

var _Switch = _interopRequireDefault(require("../Switch"));

var _units = require("../../theme/units");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FieldGroup = (0, _styledComponents["default"])(_Stack["default"]).withConfig({
  displayName: "SwitchGroup__FieldGroup",
  componentId: "aeb7v5-0"
})(function (props) {
  return (0, _styledComponents.css)(["border:0;", " ", " ", ""], props.hasSeparators && (0, _styledComponents.css)(["> label:not(:last-child) span{border-bottom:1px solid ", ";}"], props.theme.color.structure), props.justified && (0, _styledComponents.css)(["& label{width:100%;}"]), props.justified && props.leftAligned && (0, _styledComponents.css)(["label{text-align:right;}"]));
});
/**
 *
 * #### A styled component for a group of Switch type inputs

`SwitchGroup` is a helper wrapper component which takes multiple `Switch` components as children to allow for simple alignment. The `name` prop is used for grouping purposes and passed down to all child components.

Please note that this is a controlled component. Meaning, it does not have any internal state. The `value` along with the `onChange` prop allows you to hook your form state to this component. The `value` prop should hold the array containing the values of all the checkboxes in the group. While the `onChange` prop will return the event of the change along with the new value array (if required).

### Importing
`import SwitchGroup from '@blueprism/ui-core/components/SwitchGroup';`
 */

function SwitchGroup(_ref) {
  var children = _ref.children,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? _units.formAlign.left : _ref$align,
      _ref$displayType = _ref.displayType,
      displayType = _ref$displayType === void 0 ? _units.formDisplayType["default"] : _ref$displayType,
      _ref$hasSeparators = _ref.hasSeparators,
      hasSeparators = _ref$hasSeparators === void 0 ? false : _ref$hasSeparators,
      name = _ref.name,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? [] : _ref$value,
      rest = _objectWithoutProperties(_ref, ["children", "align", "displayType", "hasSeparators", "name", "onChange", "value"]);

  function createNewCheckedValues(checked, targetValue) {
    if (checked) {
      return [].concat(_toConsumableArray(value), [targetValue]);
    } else {
      return value.filter(function (itemValue) {
        return itemValue !== targetValue;
      });
    }
  }

  function handleChange(event) {
    var _event$target = event.target,
        checked = _event$target.checked,
        targetValue = _event$target.value;
    var newValue = createNewCheckedValues(checked, targetValue);
    onChange(event, newValue);
  }

  return /*#__PURE__*/_react["default"].createElement(FieldGroup, _extends({
    gap: "xs",
    element: "fieldset",
    justified: displayType === _units.formDisplayType.justified,
    leftAligned: align === _units.formAlign.left,
    hasSeparators: hasSeparators
  }, rest), _react["default"].Children.map(children, function (child) {
    return child.type === _Switch["default"] && /*#__PURE__*/_react["default"].cloneElement(child, {
      name: name,
      align: align,
      displayType: displayType,
      onChange: handleChange,
      checked: value.includes(child.props.value)
    });
  }));
}